/** Experiments => string */
export const wrapExperiments = (experiments: Record<string, string>): string => {
  return Object.keys(experiments).reduce((prev, current) => {
    const exp = `${current}.${String(experiments[current])}`;
    return prev ? `${prev}|${exp}` : exp;
  }, '');
};
